import { State } from "../../interfaces";
import { CreateMediaError } from "../../interfaces/media";
import { CreatePlanRequest } from "../../interfaces/plan";
import { PlanDto } from "../../interfaces/plan/plan.dto";
import { UpdatePlanRequest } from "../../interfaces/plan/update-plan-request.interface";
import { SelectListDto } from "../../models";
import {
  ActionTypes,
  ADD_PLAN,
  ADD_PLAN_ERROR,
  ADD_PLAN_SUCCESS,
  DELETE_PLAN,
  DELETE_PLAN_CONSENT,
  DELETE_PLAN_ERROR,
  DELETE_PLAN_SUCCESS,
  GET_PLAN,
  GET_PLAN_ERROR,
  GET_PLAN_SUCCESS,
  GET_PLANS,
  GET_PLANS_ERROR,
  GET_PLANS_SUCCESS,
  GET_PURCHASEABLE_PLANS_FOR_STUDENT,
  GET_PURCHASEABLE_PLANS_FOR_STUDENT_ERROR,
  GET_PURCHASEABLE_PLANS_FOR_STUDENT_SUCCESS,
  REMOVE_UPLOADED_PLAN_IMAGE,
  RESET_PURCHASEABLE_PLANS_FOR_STUDENT,
  SET_INITIAL_PLAN_IMAGES,
  TOGGLE_ADD_EDIT_PLAN_MODAL,
  TOGGLE_PLAN_STATE,
  TOGGLE_PLAN_STATE_ERROR,
  TOGGLE_PLAN_STATE_SUCCESS,
  UPDATE_PLAN,
  UPDATE_PLAN_ERROR,
  UPDATE_PLAN_SUCCESS,
  UPLOAD_PLAN_IMAGE,
  UPLOAD_PLAN_IMAGE_ERROR,
  UPLOAD_PLAN_IMAGE_PROGRESS,
  UPLOAD_PLAN_IMAGE_SUCCESS,
} from "./actionTypes";

export class PlanState {
  plans!: State<PlanDto[]>;
  addPlan!: State<CreatePlanRequest>;
  updatePlan!: State<UpdatePlanRequest>;
  plan!: State<PlanDto>;
  uploadPlanImage!: State<any>[];
  deletePlan!: State<any>;
  togglePlanState: any;
  purchaseablePlansForStudent: State<SelectListDto[]>;
  constructor() {
    this.updatePlan = {
      loading: false,
      error: null,
      success: false,
    };
    this.plan = {
      loading: false,
      error: null,
      success: false,
    };
    this.plans = {
      loading: false,
      error: null,
      success: false,
    };
    this.uploadPlanImage = [];
    this.addPlan = {
      loading: false,
      error: null,
      success: false,
    };
    this.deletePlan = {
      loading: false,
      error: null,
      success: false,
    };
    this.togglePlanState = {
      loading: false,
      error: null,
      success: false,
    };
    this.purchaseablePlansForStudent = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: PlanState = new PlanState();

export const plan = (state: PlanState = initialState, action: ActionTypes) => {
  switch (action.type) {
    case GET_PLANS:
      state = {
        ...state,
        plans: {
          ...state.plans,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_PLANS_SUCCESS:
      state = {
        ...state,
        plans: {
          ...state.plans,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_PLANS_ERROR:
      state = {
        ...state,
        plans: {
          ...state.plans,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_PLAN:
      state = {
        ...state,
        plan: {
          ...state.plan,
          loading: true,
          success: false,
          error: null,
        },
        updatePlan: {
          ...state.updatePlan,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_PLAN_SUCCESS:
      state = {
        ...state,
        plan: {
          ...state.plan,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_PLAN_ERROR:
      state = {
        ...state,
        plan: {
          ...state.plan,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_PLAN:
      state = {
        ...state,
        addPlan: {
          ...state.addPlan,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_PLAN_SUCCESS:
      state = {
        ...state,
        addPlan: {
          ...state.addPlan,
          loading: false,
          error: null,
          success: true,
        },
        plans: {
          ...state.plans,
          response: [action.payload, ...(state.plans.response as PlanDto[])],
        },
      };
      break;
    case ADD_PLAN_ERROR:
      state = {
        ...state,
        addPlan: {
          ...state.addPlan,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPDATE_PLAN:
      state = {
        ...state,
        updatePlan: {
          ...state.updatePlan,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_PLAN_SUCCESS:
      state = {
        ...state,
        updatePlan: {
          ...state.updatePlan,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
        plan: {
          ...state.plan,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case UPDATE_PLAN_ERROR:
      state = {
        ...state,
        updatePlan: {
          ...state.updatePlan,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_PLAN_IMAGE:
      const updatedImages = state.uploadPlanImage.map((item) =>
        item.localId === action.payload.localId
          ? {
              ...item,
              loading: true,
              success: false,
              error: null,
              progress: 0,
              response: null,
            }
          : item
      );
      const imagesExist = updatedImages.some(
        (item) => item.localId === action.payload.localId
      );
      state = {
        ...state,
        uploadPlanImage: imagesExist
          ? updatedImages
          : [
              ...updatedImages,
              {
                loading: true,
                success: false,
                error: null,
                localId: action.payload.localId as number,
                progress: 0,
                response: null,
              },
            ],
      };
      break;
    case UPLOAD_PLAN_IMAGE_SUCCESS:
      state = {
        ...state,
        uploadPlanImage: state.uploadPlanImage.map((um) => {
          if (um.localId == action.payload.localId) {
            return {
              loading: false,
              success: true,
              error: null,
              localId: um.localId,
              progress: um.progress,
              response: action.payload.media,
            };
          }
          return um;
        }),
      };
      break;
    case UPLOAD_PLAN_IMAGE_ERROR:
      state = {
        ...state,
        uploadPlanImage: state.uploadPlanImage.map((um) => {
          if (um.localId == action.payload.localId) {
            return {
              loading: false,
              success: false,
              error: (action.payload as CreateMediaError).error,
              localId: um.localId,
              progress: um.progress,
              response: null,
            };
          }
          return um;
        }),
      };
      break;
    case UPLOAD_PLAN_IMAGE_PROGRESS:
      state = {
        ...state,
        uploadPlanImage: state.uploadPlanImage.map((um) => {
          if (um.localId == action.payload.localId) {
            return {
              loading: true,
              success: false,
              error: null,
              localId: um.localId,
              progress: action.payload.progress,
              response: null,
            };
          }
          return um;
        }),
      };
      break;
    case REMOVE_UPLOADED_PLAN_IMAGE:
      state = {
        ...state,
        uploadPlanImage: state.uploadPlanImage.filter(
          (um) => um.localId != action.payload
        ),
      };
      break;
    case SET_INITIAL_PLAN_IMAGES:
      state = {
        ...state,
        uploadPlanImage: action.payload.map((image: any, index: number) => ({
          loading: false,
          success: true,
          error: null,
          localId: index + 1,
          progress: 100,
          response: { ...image },
        })),
      };
      break;
    case DELETE_PLAN_CONSENT:
      state = {
        ...state,
        deletePlan: {
          ...state.deletePlan,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_PLAN:
      state = {
        ...state,
        deletePlan: {
          ...state.deletePlan,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_PLAN_SUCCESS:
      state = {
        ...state,
        deletePlan: {
          ...state.deletePlan,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_PLAN_ERROR:
      state = {
        ...state,
        deletePlan: {
          ...state.deletePlan,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case TOGGLE_PLAN_STATE:
      state = {
        ...state,
        togglePlanState: {
          ...state.togglePlanState,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_PLAN_STATE_SUCCESS:
      state = {
        ...state,
        togglePlanState: {
          ...state.togglePlanState,
          loading: false,
          error: null,
          success: true,
        },
        plans: {
          ...state.plans,
          response: state.plans?.response?.map((subject: PlanDto) => {
            if (subject.id === action.payload.id)
              return { ...subject, isActive: !subject.isActive };
            return subject;
          }),
        },
      };
      break;
    case TOGGLE_PLAN_STATE_ERROR:
      state = {
        ...state,
        togglePlanState: {
          ...state.togglePlanState,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;

    case TOGGLE_ADD_EDIT_PLAN_MODAL:
      state = {
        ...state,
        plan: {
          ...state.plan,
          loading: true,
          success: false,
          error: null,
          response: undefined,
        },
        addPlan: {
          ...state.addPlan,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
        updatePlan: {
          ...state.updatePlan,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
        uploadPlanImage: [],
      };
      break;
    case GET_PURCHASEABLE_PLANS_FOR_STUDENT:
      state = {
        ...state,
        purchaseablePlansForStudent: {
          ...state.purchaseablePlansForStudent,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_PURCHASEABLE_PLANS_FOR_STUDENT_SUCCESS:
      state = {
        ...state,
        purchaseablePlansForStudent: {
          ...state.purchaseablePlansForStudent,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_PURCHASEABLE_PLANS_FOR_STUDENT_ERROR:
      state = {
        ...state,
        purchaseablePlansForStudent: {
          ...state.purchaseablePlansForStudent,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_PURCHASEABLE_PLANS_FOR_STUDENT:
      state = {
        ...state,
        purchaseablePlansForStudent: {
          ...state.purchaseablePlansForStudent,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
